import { schema } from "normalizr";

export const publicGroup = new schema.Entity("publicGroups");

export const privateGroup = new schema.Entity("privateGroups");
